import { Component } from '@verndale/core';
import { ExtendedWindowType } from '../helpers/global-types';

class Footer extends Component {
  constructor(el: HTMLElement) {
    super(el);
    this.generateDate();
    this.equalizeColumnTitleHeights();
  }

  setupDefaults() {
    this.dom = {
      el: this.el,
      footerLegalCopy: this.el.querySelector<HTMLFormElement>(
        '.footer__legal-copy'
      ),
      navigationColumns: this.el.querySelectorAll<HTMLElement>(
        '.footer__navigation-column-title'
      )
    };
  }

  addListeners(): void {
    this.el.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(e: Event) {
    const target = e.target as HTMLElement;
    if (target?.classList.contains('footer__navigation-link')) {
      (window as ExtendedWindowType).dataLayer.push({
        event_attributes: {},
        event: 'nav_click',
        event_category: 'navigation',
        event_action: 'footer nav',
        event_label: target.innerHTML.toString().trim()
      });
    }
  }

  generateDate() {
    const currentYear = new Date().getFullYear();
    const footerLegalCopy = this.dom.footerLegalCopy as HTMLFormElement;
    footerLegalCopy.innerHTML = footerLegalCopy.innerHTML.replace(
      '{0}',
      currentYear.toString()
    );
  }

  equalizeColumnTitleHeights() {
    const navigationColumns = this.dom.navigationColumns;

    if (navigationColumns instanceof NodeList) {
      const columnsArray = Array.from(navigationColumns);

      let maxHeight = 0;
      for (const column of columnsArray) {
        const columnHeight = column.offsetHeight;
        if (columnHeight > maxHeight) {
          maxHeight = columnHeight;
        }
      }

      // Set the same height for all column titles
      for (const column of columnsArray) {
        column.style.height = maxHeight + 'px';
      }
    }
  }
}

export default Footer;
